import { Button, TextField } from '@mui/material';
import React, { useState, useEffect, useRef } from 'react';
import CustTable from '../comp/custtable/custtable';
import RefreshIcon from '@mui/icons-material/Refresh';
import EmployeeMod from './employeemod';

// Employees of the logged-in user's own company. Edit only: there is no
// add or delete here by design.
const Employees = ({ token }) => {
    const [items, setItems] = useState([]);
    const [[start, end], setSEnd] = useState([0, 20])
    const [sstr, setSearch] = useState("");
    const [allcont, setAllCount] = useState(0);
    const [loading, setLoad] = useState(true);
    const [modmodal, setModModal] = useState(false);
    const [emprow, setemprow] = useState([]);

    const nameref = useRef();

    const columns = [
        { field: 'emp_id', headerName: 'Ажилтны код', width: 130 },
        { field: 'username', headerName: 'Нэвтрэх нэр', width: 150 },
        { field: 'emp_lastname', headerName: 'Овог', width: 150 },
        { field: 'emp_firstname', headerName: 'Нэр', width: 150 },
        { field: 'phone_number', headerName: 'Утас', width: 130 },
        { field: 'bank_account', headerName: 'Дансны дугаар', width: 220 },
    ];

    const rowClick = (e) => {
        setemprow(e);
        setModModal(true);
    }

    useEffect(() => {
        var url = 'https://wms-cloud.com/api/Employee?_start='+start+'&_end='+end;
        //var url = 'http://localhost:8080/Employee?_start='+start+'&_end='+end;
        if(sstr!="")
        {
            url=url+'&name=' + encodeURIComponent(sstr);
        }
        const request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'Access-Control-Allow-Headers': 'X-Total-Count'
            })
        });
        fetch(request).then(
            (response) => {
                if (response.status == 200) {
                    setAllCount(response.headers.get('X-Total-Count'));
                    return response.json();
                } else if (response.status == 403) {
                    alert("Эрх байхгүй байна.");
                } else if (response.status == 500) {
                    alert("Алдаа гарлаа дахин оролдоно уу.");
                } else {
                    localStorage.removeItem('tok');
                    window.location.reload(false);
                    alert("Алдаа гарлаа.")
                }
            }
        ).then((resp) => {
            setItems(resp || []);
            setLoad(false);
        });

    }, [start, end, sstr])

    const handlePage = (e) => {
        setLoad(true);
        setSEnd([e * 20, (e * 20) + 20]);
    }

    const nameChange = (e) =>{
        if (e.keyCode == 13) {
            setLoad(true);
            setSEnd([0, 20]);
            setSearch(nameref.current.value);
        }
    }

    const empRefresh = () => {
        window.location.reload(false);
    }

    return <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
        <div className="parenthead">
            <div>
                <h3>Ажилтан</h3>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <TextField inputRef={nameref} size="small" label="Нэр, кодоор хайх" onKeyDown={nameChange} />
                <Button variant="outlined" style={{ height: "40px" }} onClick={empRefresh}> <RefreshIcon /> </Button>
            </div>
        </div>
        <div className="tablecont">
            <CustTable
                name={"Employees"}
                columns={columns}
                items={items}
                allcont={allcont}
                handlePage={handlePage}
                rowClick={rowClick}
                loading={loading} />
        </div>
        {modmodal ?
        <EmployeeMod handleClose={setModModal}
        token={token}
        open={modmodal}
        emprow={emprow}
        handleRefresh={empRefresh}
        handleModal={setModModal} /> : <></>
        }
    </div>

}

export default Employees;
